import { MODULE, MODULE_NAME, PERMISSIONS, PERMISSION_ABILITY } from "../../constants"

export type TMenu = {
  name: string;
  uri: string;
  icon: string;
  code: string;
  description?: string;
  id?: number;
  disabled?: boolean;
  isMain?: boolean;
  order?: number;
  path: string;
  serviceCode?: string;
  classNameIcon?: string;
  subs?: TMenu[];
  [x: string]: any;
  hasBullet?: boolean;
  permission: string;
  ability: string;
};

export const allMenu: TMenu[] = [
  {
    name: "GENERAL.APP.NAME",
    path: "/personal-information",
    code: MODULE_NAME.HO_SO,
    permission: PERMISSIONS.MODULE,
    ability: MODULE.HO_SO,
    icon: "/media/icons/homepage/profile.svg",
    uri: "/personal-information",
    subs: [
      {
        name: "GENERAL.OVERVIEW",
        path: "/personal-information/statistical",
        hasBullet: false,
        icon: "/media/icons/overview-side.svg",
        permission: PERMISSIONS.THONG_KE,
        ability: PERMISSION_ABILITY.VIEW,
        uri: "/personal-information/statistical",
        subs: [
          {
            name: "GENERAL.STATISTICAL",
            path: "/personal-information/statistical",
            hasBullet: false,
            icon: "/media/icons/statistical.svg",
            permission: PERMISSIONS.THONG_KE,
            ability: PERMISSION_ABILITY.VIEW,
            code: "",
            uri: "/personal-information/statistical"
          },
          {
            name: "REMIND",
            path: "/personal-information/remind",
            hasBullet: false,
            icon: "/media/icons/remind2.svg",
            permission: PERMISSIONS.REMIND,
            ability: PERMISSION_ABILITY.VIEW,
            code: "",
            uri: "/personal-information/remind"
          },
        ],
        code: ""
      },
      {
        name: "GENERAL.WARNING",
        path: "/personal-information/warning",
        hasBullet: false,
        icon: "/media/icons/warning.svg",
        permission: PERMISSIONS.CANH_BAO,
        ability: PERMISSION_ABILITY.VIEW,
        code: "",
        uri: "/personal-information/warning"
      },
      {
        name: "GENERAL.PROFILE",
        path: "/personal-information/profile",
        hasBullet: false,
        icon: "/media/icons/profile.svg",
        permission: PERMISSIONS.EMPLOYEE,
        ability: PERMISSION_ABILITY.VIEW,
        code: "",
        uri: "/personal-information/profile"
      },
      {
        name: "GENERAL.CONTRACT",
        path: "/personal-information/contract",
        hasBullet: false,
        icon: "/media/icons/contract.svg",
        permission: PERMISSIONS.HOP_DONG,
        ability: PERMISSION_ABILITY.VIEW,
        code: "",
        uri: "/personal-information/contract"
      },
      {
        name: "DECLARE_ASSETS",
        path: "/personal-information/declare-assets",
        hasBullet: false,
        icon: "/media/icons/demand-registration.svg",
        permission: PERMISSIONS.KE_KHAI_TAI_SAN_MENU,
        ability: PERMISSION_ABILITY.VIEW,
        code: "",
        uri: "/personal-information/declare-assets"
      },
      {
        name: "GENERAL.TRANSFER",
        path: "/personal-information/transition",
        hasBullet: false,
        icon: "/media/icons/transition.svg",
        permission: PERMISSIONS.THUYEN_CHUYEN,
        ability: PERMISSION_ABILITY.VIEW,
        code: "",
        uri: "/personal-information/transition"
      },
      {
        name: "GENERAL.RESIGN",
        path: "/personal-information/resign",
        hasBullet: false,
        icon: "/media/icons/resign.svg",
        permission: PERMISSIONS.NGHI_VIEC,
        ability: PERMISSION_ABILITY.VIEW,
        code: "",
        uri: "/personal-information/resign"
      },
      {
        name: "APPOINTMENT",
        path: "/personal-information/appointment",
        hasBullet: false,
        icon: "/media/icons/appointment.svg",
        permission: PERMISSIONS.BO_NHIEM,
        ability: PERMISSION_ABILITY.VIEW,
        code: "",
        uri: "/personal-information/appointment"
      },
      {
        name: "DISMISSED",
        path: "/personal-information/dismissed",
        hasBullet: false,
        icon: "/media/icons/dismissed.svg",
        permission: PERMISSIONS.MIEN_NHIEM,
        ability: PERMISSION_ABILITY.VIEW,
        code: "",
        uri: "/personal-information/dismissed"
      },
      {
        name: "WELFARE",
        path: "/personal-information/welfare",
        hasBullet: false,
        icon: "/media/icons/welfare.svg",
        permission: PERMISSIONS.PHUC_LOI_MENU,
        ability: PERMISSION_ABILITY.VIEW,
        code: "",
        uri: "/personal-information/welfare"
      },
      {
        name: "CONCURRENTLY",
        path: "/personal-information/concurrently",
        hasBullet: false,
        icon: "/media/icons/concurrently.svg",
        permission: PERMISSIONS.KIEM_NHIEM,
        ability: PERMISSION_ABILITY.VIEW,
        code: "",
        uri: "/personal-information/concurrently"
      },
      {
        name: "SECONDMENT",
        path: "/personal-information/secondment",
        hasBullet: false,
        icon: "/media/icons/secondment.svg",
        permission: PERMISSIONS.BIET_PHAI,
        ability: PERMISSION_ABILITY.VIEW,
        code: "",
        uri: "/personal-information/secondment"
      },
      {
        name: "GENERAL.APPRECIATIVE",
        path: "/personal-information/appreciative",
        hasBullet: false,
        icon: "/media/icons/appreciative.svg",
        permission: PERMISSIONS.KHEN_THUONG_MENU,
        ability: PERMISSION_ABILITY.VIEW,
        code: "",
        uri: "/personal-information/appreciative"
      },
      {
        name: "GENERAL.DISCIPLINE",
        path: "/personal-information/discipline",
        hasBullet: false,
        icon: "/media/icons/issue.svg",
        permission: PERMISSIONS.KY_LUAT_MENU,
        ability: PERMISSION_ABILITY.VIEW,
        code: "",
        uri: "/personal-information/discipline"
      },
      {
        name: "GENERAL.RECEIVING_CITIZENS",
        path: "/personal-information/receiving-citizens",
        hasBullet: false,
        classNameIcon: "svg-color",
        icon: "/media/icons/sitting-svgrepo-com.svg",
        permission: PERMISSIONS.TIEP_CONG_DAN,
        ability: PERMISSION_ABILITY.VIEW,
        code: "",
        uri: "/personal-information/receiving-citizens"
      },
      {
        name: "GENERAL.SEND_PEOPLE_TRAINING",
        path: "/personal-information/send-people-training",
        hasBullet: false,
        icon: "/media/icons/graduation-cap.svg",
        permission: PERMISSIONS.CU_DAO_TAO,
        ability: PERMISSION_ABILITY.VIEW,
        code: "",
        uri: "/personal-information/send-people-training"
      },
      {
        name: "GENERAL.REPORT",
        path: "/personal-information/report",
        hasBullet: false,
        icon: "/media/icons/report.svg",
        permission: PERMISSIONS.BAO_CAO,
        ability: PERMISSION_ABILITY.VIEW,
        code: "",
        uri: "/personal-information/report"
      },
      {
        name: "MANAGER",
        path: "/personal-information/manager",
        hasBullet: false,
        icon: "/media/icons/manager.svg",
        permission: PERMISSIONS.MANAGEMENT,
        ability: PERMISSION_ABILITY.VIEW,
        code: "",
        uri: "/personal-information/manager"
      }
    ]
  },
  {
    name: "GENERAL.TIME_KEEPING",
    path: "/timekeeping/overview",
    code: "timekeeping",
    permission: PERMISSIONS.MODULE,
    ability: MODULE.CHAM_CONG,
    icon: "/media/icons/homepage/time.svg",
    uri: "/timekeeping/overview",
    subs: [
      {
        name: "TIMEKEEPING.OVERVIEW",
        path: "/timekeeping/overview",
        hasBullet: false,
        icon: "/media/icons/overview-side.svg",
        permission: PERMISSIONS.CHAM_CONG_TONG_QUAN,
        ability: PERMISSION_ABILITY.VIEW,
        code: "",
        uri: "/timekeeping/overview"
      },
      {
        name: "GENERAL.TIME_KEEPING",
        path: "/timekeeping/timesheet",
        hasBullet: false,
        icon: "/media/icons/timeSheet.svg",
        permission: PERMISSIONS.BANG_CHAM_CONG,
        ability: PERMISSION_ABILITY.VIEW,
        code: "",
        uri: "/timekeeping/timesheet"
      },
      {
        name: "TIMEKEEPING.SHIFT",
        path: "/timekeeping/shift-division",
        hasBullet: false,
        icon: "/media/icons/calendar-check.svg",
        permission: PERMISSIONS.CA_LAM_VIEC,
        ability: PERMISSION_ABILITY.VIEW,
        uri: "/timekeeping/shift-division",
        subs: [
          {
            name: "TIMEKEEPING.UPDATE_WORK_SHIFT",
            path: "/timekeeping/work-shifts",
            hasBullet: false,
            icon: "/media/icons/calendar-lines-pen.svg",
            permission: PERMISSIONS.GIAO_CA,
            ability: PERMISSION_ABILITY.VIEW,
            code: "",
            uri: "/timekeeping/work-shifts"
          },
          {
            name: "TIMEKEEPING.COMPREHENSIVE_SHIFT",
            path: "/timekeeping/comprehensive-shift",
            hasBullet: false,
            icon: "/media/icons/calendar-star.svg",
            permission: PERMISSIONS.PHAN_CA_TONG_HOP,
            ability: PERMISSION_ABILITY.VIEW,
            code: "",
            uri: "/timekeeping/comprehensive-shift"
          },
          {
            name: "TIMEKEEPING.SHIFT_DIVISION.DOCTOR",
            path: "/timekeeping/shift-division-doctor",
            hasBullet: false,
            icon: "/media/icons/calendar-circle-plus.svg",
            permission: PERMISSIONS.PHAN_CA_BAC_SI,
            ability: PERMISSION_ABILITY.VIEW,
            code: "",
            uri: "/timekeeping/shift-division-doctor"
          },
          {
            name: "TIMEKEEPING.SHIFT_DIVISION.NURSING",
            path: "/timekeeping/shift-division-nursing",
            hasBullet: false,
            icon: "/media/icons/calendar-circle-plus.svg",
            permission: PERMISSIONS.PHAN_CA_DIEU_DUONG,
            ability: PERMISSION_ABILITY.VIEW,
            code: "",
            uri: "/timekeeping/shift-division-nursing"
          },
          {
            name: "TIMEKEEPING.SCHEDULE.OFFICE_WORK",
            path: "/timekeeping/office-work-schedule",
            hasBullet: false,
            icon: "/media/icons/calendar-pen.svg",
            permission: PERMISSIONS.LICH_HANH_CHINH,
            ability: PERMISSION_ABILITY.VIEW,
            code: "",
            uri: "/timekeeping/office-work-schedule"
          },
          {
            name: "TIMEKEEPING.SHIFT",
            path: "/timekeeping/shift",
            hasBullet: false,
            icon: "/media/icons/clipboard-list-check.svg",
            permission: PERMISSIONS.CA_LAM_VIEC,
            ability: PERMISSION_ABILITY.VIEW,
            code: "",
            uri: "/timekeeping/shift"
          }
        ],
        code: ""
      },
      {
        name: "TIMEKEEPING.MANAGENT_REQUEST",
        path: "/timekeeping/management-request/attendance-watch",
        hasBullet: false,
        icon: "/media/icons/demand-registration.svg",
        permission: PERMISSIONS.DON_TU,
        ability: PERMISSION_ABILITY.VIEW,
        uri: "/timekeeping/management-request/attendance-watch",
        subs: [
          {
            name: "TIMEKEEPING.MANAGENT_REQUEST.ATTENDANCE_WATCH",
            path: "/timekeeping/management-request/attendance-watch",
            hasBullet: false,
            icon: "/media/icons/contract.svg",
            permission: PERMISSIONS.DON_XIN_NGHI,
            ability: PERMISSION_ABILITY.VIEW,
            code: "",
            uri: "/timekeeping/management-request/attendance-watch"
          },
          {
            name: "TIMEKEEPING.MANAGENT_REQUEST.REGISTER_OVERTIME",
            path: "/timekeeping/management-request/register-overtime",
            hasBullet: false,
            icon: "/media/icons/contract.svg",
            permission: PERMISSIONS.DON_DANG_KI_LAM_THEM,
            ability: PERMISSION_ABILITY.VIEW,
            code: "",
            uri: "/timekeeping/management-request/register-overtime"
          },
          {
            name: "MANAGENT_REQUEST.CHANGE_COMPENSATED",
            path: "/timekeeping/management-request/change-compensated",
            hasBullet: false,
            icon: "/media/icons/contract.svg",
            permission: PERMISSIONS.DON_DOI_CA_NGHI_BU,
            ability: PERMISSION_ABILITY.VIEW,
            code: "",
            uri: "/timekeeping/management-request/change-compensated"
          }
        ],
        code: ""
      },
      {
        name: "CATEGORY",
        path: "/timekeeping/category",
        hasBullet: false,
        icon: "/media/icons/category.svg",
        permission: PERMISSIONS["DANH_MUC.CHAM_CONG"],
        ability: PERMISSION_ABILITY.VIEW,
        uri: "/timekeeping/category",
        subs: [
          {
            name: "SYMBOL",
            path: "/timekeeping/category/symbol",
            hasBullet: false,
            icon: "/media/icons/book.svg",
            permission: PERMISSIONS["DANH_MUC.CHAM_CONG.KY_HIEU"],
            ability: PERMISSION_ABILITY.VIEW,
            code: "",
            uri: "/timekeeping/category/symbol"
          },
          {
            name: "LEAVE_REGULATIONS",
            path: "/timekeeping/category/leave-regulations",
            hasBullet: false,
            icon: "/media/icons/calendar-days.svg",
            permission: PERMISSIONS["DANH_MUC.CHAM_CONG.QUY_DINH_NGHI"],
            ability: PERMISSION_ABILITY.VIEW,
            code: "",
            uri: "/timekeeping/category/leave-regulations"
          },
          {
            name: "APPROVAL_CONFIG",
            path: "/timekeeping/category/approval-config",
            hasBullet: false,
            icon: "/media/icons/wrench.svg",
            permission: PERMISSIONS["DANH_MUC.CHAM_CONG.CAU_HINH_DUYET"],
            ability: PERMISSION_ABILITY.VIEW,
            code: "",
            uri: "/timekeeping/category/approval-config"
          },
          {
            name: "SCHEDULE_CONFIG",
            path: "/timekeeping/category/schedule-config",
            hasBullet: false,
            icon: "/media/icons/calendar-days.svg",
            permission: PERMISSIONS["DANH_MUC.CHAM_CONG.CAU_HINH_DUYET"],
            ability: PERMISSION_ABILITY.VIEW,
            code: "",
            uri: "/timekeeping/category/schedule-config"
          }
        ],
        code: ""
      },
    ]
  },
  {
    name: "GENERAL.RECRUITMENT",
    path: "/recruitment",
    defaultTo: "/recruitment",
    code: "recruitment",
    permission: PERMISSIONS.MODULE,
    ability: MODULE.TUYEN_DUNG,
    icon: "/media/icons/homepage/hr.svg",
    subs: [],
    uri: "/recruitment"
  },
  {
    name: "GENERAL.DOCUMENT",
    path: "/document",
    defaultTo: "/document",
    code: "document",
    permission: PERMISSIONS.MODULE,
    ability: MODULE.TAI_LIEU,
    icon: "/media/icons/homepage/document.svg",
    subs: [],
    uri: "/document"
  },
  {
    name: "GENERAL.TRAINING",
    path: "/training",
    defaultTo: "/training",
    code: "training",
    permission: PERMISSIONS.MODULE,
    ability: MODULE.DAO_TAO,
    icon: "/media/icons/homepage/training.svg",
    subs: [],
    uri: "/training"
  },
  {
    name: "GENERAL.MEETING_ROOM",
    path: "/meeting-room",
    defaultTo: "/meeting-room",
    code: "meeting-room",
    permission: PERMISSIONS.MODULE,
    ability: MODULE.PHONG_HOP,
    icon: "/media/icons/homepage/meet.svg",
    subs: [],
    uri: "/meeting-room"
  },
  {
    name: "GENERAL.JOB",
    path: "/job",
    defaultTo: "/job",
    code: "job",
    permission: PERMISSIONS.MODULE,
    ability: MODULE.CONG_VIEC,
    icon: "/media/icons/homepage/work.svg",
    subs: [],
    uri: "/job"
  },
  {
    name: "GENERAL.SYSTEM",
    path: "/system",
    defaultTo: "/system",
    code: "system",
    permission: PERMISSIONS.MODULE,
    ability: MODULE.HE_THONG,
    icon: "/media/icons/homepage/system.svg",
    subs: [],
    uri: "/system"
  }
]
